import React from "react";
import PropTypes from "prop-types";
import DisplayPicture from "../DisplayPicture/DisplayPicture";

import style from "./ComponentContainer.module.css";

export default function ComponentContainer({
  children,
  image,
  title,
  containerStyles,
  innerContainerStyles,
  headerStyles,
  containerBodyStyle,
  isLocalImage,
  showBackBtn = false,
  backActionHandler,
}) {
  return (
    <div className={`${style.container} ${containerStyles}`}>
      <div className={`${style.innerContainer} ${innerContainerStyles}`}>
        <div className={`${style.header} ${headerStyles}`}>
          <button
            className={`noBgBtn ${style.backBtnStyle} ${
              !showBackBtn && "d-none"
            }`}
            onClick={backActionHandler}
          >
            <span className="mdi mdi-arrow-left mr-2 pl-0 ml-0"></span>
          </button>
          <DisplayPicture
            image={image}
            isLocalImage={isLocalImage}
            className="profileImage"
          />
          <div className={`${style.title} senaryColor ml-2`}>{title}</div>
        </div>
        <div
          className={
            containerBodyStyle
              ? containerBodyStyle
              : `p-4 tertiaryScrollBar ${style.children}`
          }
        >
          {children}
        </div>
      </div>
    </div>
  );
}

ComponentContainer.propTypes = {
  image: PropTypes.string,
  title: PropTypes.string,
  container: PropTypes.object,
  innerContainer: PropTypes.object,
  showBackBtn: PropTypes.bool,
  backActionHandler: PropTypes.func,
};
